import { trackEvent } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import React from 'react'
import InfoSectionHeader from './InfoSectionHeader'
import FieldWrapper from '../../ui/FieldWrapper'
import { useOverlayContext } from '../../../../../../shared/providers/overlayContextProvider/OverlayContext'
import IndexInfoSection from './IndexInfoSection'
import Subsection from './Subsection'
import NoDataAddedMessage from './NoDataAddedMessage'

const AgeSection = ({ age, isRestrictedAgeField, disableEdit }) => {
  const { openOverlay, infoSheetOverlay } = useOverlayContext()
  const { t } = useTranslation()

  return (
    <>
      {age && age.subElements?.length > 0 && (
        <IndexInfoSection
          element={age}
          onEditClick={() => {
            openOverlay('editAge')
            trackEvent({
              event_name: 'click_action',
              link_name: `Edit: Age: Open`,
            })
          }}
          disableEditButton={isRestrictedAgeField || disableEdit}
          isBottomSheet={infoSheetOverlay?.isBottomSheet}
          growX
        />
      )}
      {!age?.subElements?.length && (
        <>
          <InfoSectionHeader
            element={{ label: t('view-index.age.title', 'Age'), elementType: 'age' }}
            disabled={isRestrictedAgeField || disableEdit}
            onEditClick={() => {
              openOverlay('editAge')
              trackEvent({
                event_name: 'click_action',
                link_name: `Edit: Age: Open`,
              })
            }}
          />
          <Subsection>
            <FieldWrapper>
              <NoDataAddedMessage />
            </FieldWrapper>
          </Subsection>
        </>
      )}
    </>
  )
}

export default AgeSection
